<template>
  <!--地区组件-->
 <!--  <div class="block">
    <label>{{item_data.title}}<span v-show="item_data.is_require == 1">*</span></label> -->
  <div  class="selmul uploa-bg" style="padding: 10px 0 10px 5%">
    <select v-model="prov" @change="onClickMe1" style="height: 35px">
      <option value="">请选择</option>
      <option v-for="(option,idx) in options" :value="option.value">
        {{ option.value }}
      </option>
    </select>
    <select v-model="city"  @change="onClickMe2" v-if="idx >=0" style="height: 35px">
      <option value="">请选择</option>
      <option v-for="option in options1" :value="option.value">
        {{ option.value }}
      </option>
    </select>
   <!--  <select class="districts" v-model="district" v-if="districtArr"  @change="onClickMe3" style="height: 35px">
      <option v-for="option in districtArr" :value="option.name">
        {{ option.name }}
      </option>
    </select> -->
  </div>
  <!-- </div> -->
</template>

<script>
  export default {
    props: [
      'item_data'
    ],
    data (){
    return {
      // arr: arrAll,
      prov: '',
      city: '',
      options: [],
      item_name: '',
      selectedOptions: [],
      idx: -1,
    }
  },
  computed:{
    options1: function(){
      return this.idx>=0? this.options[this.idx].children : []
    },

  },
  methods: {
    onClickMe1: function(event){
      // console.log(event.target.value);
      $('.selmul').removeClass('font');
      var val = event.target.value;
      this.city = ''
      this.findIdx(val);
       this.$emit('change',{
          value: [this.prov],
          name: this.item_name
        })
    },
    onClickMe2: function(){
      $('.selmul').removeClass('font');
       this.$emit('change',{
          value: [this.prov,this.city],
          name: this.item_name
        })
    },

    parseData(){
      var opts = JSON.parse(this.item_data.option_json);
      var optArr = [];
      var idx = 0;
      opts.forEach(item=>{
        if(item.level == '1'){
          var obj = {
            value: item.val,
            label: item.val,
            children: []
          }
          optArr.push(obj);
          idx = optArr.length -1;
        }else{
          optArr[idx].children.push({
            value: item.val,
            label: item.val
          })
        }
      })
      this.options = optArr;
    },
    initData(){
      var that = this;
      that.item_name = that.item_data.name;
      let def_val = that.item_data.isChoose;
      if(def_val){
        that.selectedOptions = def_val.split(',')
        that.prov =that.selectedOptions[0] || '';
        that.city =that.selectedOptions[1] || '';
        if(this.prov){
          this.findIdx(this.prov)
        }
        that.$emit('change',{
          value: that.selectedOptions,
          name: that.item_name
        })
      }
    },
    findIdx(val){
      this.idx =  this.options.findIndex((v,i)=>{
         return val == v.value
      })
    }
  },

  created: function () {
    var that = this;
    that.parseData();
    that.initData();

  },
  mounted: function () {
    //操作DOM

  }

}

</script>

<style>
.selmul select{
  width: 30%;;
}
</style>



// WEBPACK FOOTER //
// src/components/template/selectmul.vue